import { cn, CATEGORY_COLORS } from "../../lib/utils";
import { Check } from "lucide-react";

export function ProgressBar({ categories, progress, currentCategory, onCategoryClick }) {
  return (
    <div className="w-full" data-testid="progress-bar">
      {/* Mobile: Horizontal scrollable */}
      <div className="flex gap-1 overflow-x-auto hide-scrollbar pb-2 md:hidden">
        {categories.map((cat, index) => {
          const catProgress = progress?.categories?.[cat.id];
          const isComplete = catProgress?.percentage === 100;
          const isCurrent = currentCategory === cat.id;
          
          return (
            <button
              key={cat.id}
              onClick={() => onCategoryClick?.(cat.id)}
              className={cn(
                "flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center text-xs font-medium transition-all",
                isComplete && "bg-primary text-primary-foreground",
                isCurrent && !isComplete && "ring-2 ring-accent ring-offset-2",
                !isComplete && !isCurrent && "bg-muted text-muted-foreground"
              )}
              style={{
                backgroundColor: isComplete ? CATEGORY_COLORS[cat.id] : undefined,
              }}
              data-testid={`progress-category-${cat.id}`}
            >
              {isComplete ? <Check className="h-4 w-4" /> : index + 1}
            </button>
          );
        })}
      </div>
      
      {/* Desktop: Full progress bar */}
      <div className="hidden md:block">
        <div className="flex gap-1">
          {categories.map((cat) => {
            const catProgress = progress?.categories?.[cat.id];
            const percentage = catProgress?.percentage || 0;
            const isCurrent = currentCategory === cat.id;
            
            return (
              <button
                key={cat.id}
                onClick={() => onCategoryClick?.(cat.id)}
                className={cn(
                  "flex-1 h-2 rounded-full transition-all hover:scale-y-150",
                  isCurrent && "ring-1 ring-offset-1 ring-primary"
                )}
                style={{
                  background: percentage === 100
                    ? CATEGORY_COLORS[cat.id]
                    : `linear-gradient(to right, ${CATEGORY_COLORS[cat.id]} ${percentage}%, hsl(var(--muted)) ${percentage}%)`,
                }}
                title={`${cat.name}: ${percentage}%`}
              />
            );
          })}
        </div>
        
        <div className="flex justify-between mt-2 text-xs text-muted-foreground">
          {categories.map((cat) => (
            <span
              key={cat.id}
              className={cn(
                "truncate max-w-[100px] text-center",
                currentCategory === cat.id && "font-medium text-foreground"
              )}
            >
              {cat.name.split(" ")[0]}
            </span>
          ))}
        </div>
      </div>
      
      {/* Overall progress */}
      {progress?.overall && (
        <div className="mt-4 text-center">
          <span className="text-sm text-muted-foreground">
            Overall Progress: {" "}
            <span className="font-semibold text-foreground">
              {progress.overall.completed}/{progress.overall.total} items ({progress.overall.percentage}%)
            </span>
          </span>
        </div>
      )}
    </div>
  );
}
